<template>
  <div class="Trio-wrapper">
    <div class="Trio-init-chosse">
      <h1 class="Trio-main-title">¿Para qué quieres tu hipoteca?</h1>
      <ul class="Trio-boxes-list">
        <li class="Trio-box">
          <button-choose v-on:clicked="selected('afford-mortgage')">
            <figure class="Trio-img">
              <img :src="'img/' + brand + '/house-group.png'" alt />
            </figure>
            <span class="Trio-text">
              <span class="Trio-question">Qué casa me puedo comprar</span>
            </span>
          </button-choose>
        </li>
        <li class="Trio-box">
          <button-choose v-on:clicked="selected('simulate-mortgage')">
            <figure class="Trio-img">
              <img :src="'img/' + brand + '/heart-house.png'" alt />
            </figure>
            <span class="Trio-text">
              <span class="Trio-question">Simula tu hipoteca<br>ahora</span>
            </span>
          </button-choose>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import buttonChoose from "../components/buttonChoose";
import { Store } from "../store/index.js";

export default {
  name: "chooseMortgage",
  components: { buttonChoose },
  computed: {
    brand() {
      return process.env.VUE_APP_BRAND;
    }
  },
  methods: {
    selected(type) {
      Store.commit("ui/SET_TARGET_MORTGAGE", type);
    }
  }
};
</script>
